import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import SideMenuNavList from './SideMenuNavList';
import Popup from '../../components/Modal/PopUp';
import { logoutUser } from '../../store/actions/UserAction';

const mobileHeightTopAppBar = 56;
const desktopHeightTopAppBar = 64;

const useStyles = makeStyles({
  rootBackdrop: {
    top: 64,
    '@media (max-width: 599px)': {
      top: 56
    }
  },
  rootDrawer: {
    marginTop: mobileHeightTopAppBar,
  },
  drawerPaper: {
    backgroundColor: 'transparent',
    marginTop: 64,
    '@media (max-width: 599px)': {
      marginTop: 56
    },
    border: 'none',
    height: props =>
      props.isMobile
        ? `calc(100vh - ${mobileHeightTopAppBar}px)`
        : `calc(100vh - ${desktopHeightTopAppBar}px)`,
  },
});

const SideMenu = props => {
  
  const classes = useStyles(props);
  const [ openModal, setOpenModal ] = useState(false);
  const { isMobile, variant, openDrawer, handleToggleDrawer, profile, logoutUser} = props;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Popup
        open={openModal}
        handleClose={handleCloseModal}
        title='¿Quieres salir de tu sesión?'
        subtitle='Tendrás que volver a iniciar sesión para ingresar.'
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, salir'
        primaryFunction={logoutUser}
        secondaryButton={true}
        secondaryButtonVariant='primary'
      />
      <Drawer
        variant={variant}
        ModalProps={{
          BackdropProps: {
            classes: { root: classes.rootBackdrop },
          },
        }}
        PaperProps={{
          elevation: 0,
        }}
        classes={{
          root: classes.rootDrawer,
          paper: classes.drawerPaper,
        }}
        onClose={handleToggleDrawer}
        open={openDrawer}
      >
        <SideMenuNavList
          expandDrawer={true}
          handleToggleDrawer={handleToggleDrawer}
          isMobile={isMobile}
          profile={profile}
          makeOpenModal={handleOpenModal}
        />
      </Drawer>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  logoutUser: () => dispatch(logoutUser())
}); 

export default connect(null, mapDispatchToProps)(SideMenu);
